import { world } from '../../languages';
import axios from '../../utils/axios';
import { WISHLIST_BASE_FILTERS } from './query-wishlist-materials.constants';

type WishlistMembershipItem = { id: number | null };

// Returns the subset of materialIds that are in the wishlist behind `url`.
export const getWishlistMembership = async (url: string, materialIds: number[]): Promise<number[]> => {
    const schema = `{
            wishlist (
                filter: { and: [
                    { world: "${world}" }
                    ${WISHLIST_BASE_FILTERS}
                    { in: { id: [${materialIds.join(', ')}] } }
                ] },
                pagination: { limit: ${materialIds.length} }
            ) {
                    id
                }
        }`;

    const response = await axios.post(url, { query: schema });
    const wishlist: WishlistMembershipItem[] = response.data.wishlist ?? [];

    return wishlist.flatMap(({ id }) => (id ? [id] : []));
};
